import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const NavContainer = styled.nav`
    background-color: white;
    border-bottom: 1px solid ${theme.colors.lightGray};
    display: none; // Hidden for now as step wizard is self-contained, but good for structure
    
    @media (min-width: 768px) {
        display: block;
    }
`;

const NavList = styled.ul`
    display: flex;
    justify-content: center;
    max-width: 800px;
    margin: 0 auto;
`;

const NavItem = styled.li`
    
`;

const StyledLink = styled(NavLink)`
    display: block;
    padding: ${theme.spacing.medium} ${theme.spacing.large};
    color: ${theme.colors.secondary};
    font-size: 0.9rem;
    font-weight: 500;
    
    &.active {
        color: ${theme.colors.primary};
        border-bottom: 2px solid ${theme.colors.primary};
    }
    
    &:hover {
        color: ${theme.colors.primary};
    }
`;

const Navigation = () => {
    // This could serve as a secondary nav or "stepper" visualization if needed globally
    return (
       <NavContainer>
           <NavList>
               <NavItem>
                   <StyledLink exact to="/">Home</StyledLink>
               </NavItem>
               {/* 
               <NavItem>
                   <StyledLink to="/assessment">Assessment</StyledLink>
               </NavItem>
               <NavItem>
                   <StyledLink to="/results">Results</StyledLink>
               </NavItem> 
               */}
           </NavList>
       </NavContainer>
    );
};

export default Navigation;